import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedServiceService } from '../../services/shared-service.service';

/**
 * POST body for creating a member wish. Backend route: `{baseUrl}member-wishes`.
 * Adjust the path here if the API uses a different URL.
 */
@Injectable({
  providedIn: 'root',
})
export class WishesService {
  private apiBaseUrl: string;

  constructor(
    private http: HttpClient,
    private sharedService: SharedServiceService
  ) {
    this.apiBaseUrl = this.sharedService.baseUrl();
  }

  createWish(payload: unknown): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}member-wishes`;
    return this.http.post(url, payload, { headers });
  }

  /** GET /api/member-wishes/{memberId} */
  getMemberWishes(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const id = encodeURIComponent((memberId ?? '').trim());
    const url = `${this.apiBaseUrl}member-wishes/${id}`;
    return this.http.get(url, { headers });
  }

  /** GET /api/member-wishes/{memberId}/templates */
  getMemberWishTemplates(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const id = encodeURIComponent((memberId ?? '').trim());
    const url = `${this.apiBaseUrl}member-wishes/${id}/templates`;
    return this.http.get(url, { headers });
  }

  /** POST /api/member-wishes/{wishId}/template */
  saveWishAsTemplate(wishId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const id = encodeURIComponent((wishId ?? '').trim());
    const url = `${this.apiBaseUrl}member-wishes/${id}/template`;
    return this.http.post(url, {}, { headers });
  }

  /** PUT /api/member-wishes/{wishId} */
  updateWish(wishId: string, payload: unknown): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const id = encodeURIComponent((wishId ?? '').trim());
    const url = `${this.apiBaseUrl}member-wishes/${id}`;
    return this.http.put(url, payload, { headers });
  }

  /** GET /api/member-wishes/month-view/{memberId}?month={month}&year={year} (month is 1-based) */
  getMemberWishesMonthView(memberId: string, month: number, year: number): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const id = encodeURIComponent((memberId ?? '').trim());
    const base = (this.apiBaseUrl ?? '').replace(/\/+$/, '');
    const url = `${base}/member-wishes/month-view/${id}?month=${encodeURIComponent(
      String(month)
    )}&year=${encodeURIComponent(String(year))}`;
    return this.http.get(url, { headers });
  }
}
